module.exports = __webpack_public_path__ + "assets/img/explain_tit.816d7afc.png";